import { render } from "./EditPR.vue?vue&type=template&id=4b6de473"
import script from "./EditPR.vue?vue&type=script&lang=js"
export * from "./EditPR.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__